export default __webpack_public_path__ + "static/media/headphones.996ae73a.png";